(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31750],{

/***/ 31750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactUsForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/components/shared/confirmationCheck/confirmationCheck.module.scss
var confirmationCheck_module = __webpack_require__(58509);
var confirmationCheck_module_default = /*#__PURE__*/__webpack_require__.n(confirmationCheck_module);
;// CONCATENATED MODULE: ./src/components/shared/confirmationCheck/index.tsx



function ConfirmationCheck({ color  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            "--color": color ?? "black"
        },
        className: (confirmationCheck_module_default())["success-checkmark"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (confirmationCheck_module_default())["check-icon"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `${(confirmationCheck_module_default())["icon-line"]} ${(confirmationCheck_module_default())["line-tip"]}`
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `${(confirmationCheck_module_default())["icon-line"]} ${(confirmationCheck_module_default())["line-long"]}`
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (confirmationCheck_module_default())["icon-circle"]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (confirmationCheck_module_default())["icon-fix"]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/shared/loader/index.tsx
var loader = __webpack_require__(95301);
// EXTERNAL MODULE: ./src/components/shared/button/button.module.scss
var button_module = __webpack_require__(64655);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
;// CONCATENATED MODULE: ./src/components/shared/button/index.tsx




function Button(props) {
    const { className ="" , children , onClick , icon , href , target , loading , style , type ,  } = props;
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: target,
        href: href,
        className: `${(button_module_default()).button} ${className ?? ""}`,
        style: style,
        children: !loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (button_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (button_module_default()).label,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (button_module_default()).icon,
                    children: icon
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
            size: 25
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        style: style,
        className: `${(button_module_default()).button}  ${className}`,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (button_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (button_module_default()).label,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (button_module_default()).icon,
                    children: icon
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
            size: 25
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/useContactUsForm.tsx + 1 modules
var useContactUsForm = __webpack_require__(77720);
// EXTERNAL MODULE: ./src/components/shared/contactUs/styles.module.scss
var styles_module = __webpack_require__(9800);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/shared/contactUsForm.ts
var contactUsForm = __webpack_require__(37695);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/contactUs/multiSelect.tsx



function MultiSelect({ field , onChange , fieldClassName , containerClassName , value , errorText , noteText  }) {
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    const { 0: searchableValue , 1: setSearchableValue  } = (0,react.useState)("");
    const { 0: checkboxValue , 1: setCheckboxValue  } = (0,react.useState)(field.options?.filter((option)=>value.includes(option.value)) ?? []);
    const handleCheckboxChange = (value, remove)=>{
        const tempValue = [
            ...checkboxValue
        ];
        if (remove) {
            onChange(tempValue.filter((option)=>option.value !== value).map((el)=>el.value).join(","));
            return;
        }
        if (tempValue.find((option)=>option.value === value)) {
            onChange(tempValue.filter((option)=>option.value !== value).map((el)=>el.value).join(","));
        } else {
            onChange([
                ...tempValue.map((option)=>option.value),
                value
            ].join(","));
        }
    };
    const renderOptions = ()=>field?.options?.filter((option)=>option.label.toLowerCase().includes(searchableValue.trim().toLowerCase())).map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).option,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: `${field.name}-${option.value}`,
                        value: option.value,
                        name: field.name,
                        onChange: (e)=>handleCheckboxChange(e.target.value),
                        checked: !!checkboxValue?.find((el)=>el.value === option.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: `${field.name}-${option.value}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).box,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    viewBox: "0,0,50,50",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M5 30 L 20 45 L 45 5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm flex items-center",
                                style: {
                                    transform: "translateY(1px)"
                                },
                                children: option.label
                            })
                        ]
                    }, option.value)
                ]
            }, option.value));
    (0,react.useEffect)(()=>{
        setCheckboxValue(field.options?.filter((option)=>value.includes(option.value)) ?? []);
    }, [
        value
    ]);
    const changeInputHandler = (e)=>{
        setSearchableValue(e.target.value);
        setShow((prev)=>{
            if (prev === false) {
                return true;
            }
            return prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(styles_module_default())["multi-select"]} ${containerClassName ?? ""}`,
        tabIndex: 0,
        onBlur: (e)=>{
            if (e.relatedTarget === null) {
                setShow(false);
                setSearchableValue("");
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default())["multi-select-input-container"]}  ${fieldClassName}`,
                onClick: ()=>{
                    setShow((prev)=>!prev);
                },
                style: {
                    padding: "3px 15px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["multi-select-tags"],
                    children: [
                        checkboxValue?.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (styles_module_default()).tag,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: option.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "px-[6px] cursor-pointer",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            handleCheckboxChange(option.value, true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(X, {})
                                    })
                                ]
                            }, option.value)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            placeholder: field.placeholder ? field.placeholder : "Select Multiple Options",
                            className: (styles_module_default())["multi-select-input"],
                            value: searchableValue,
                            onChange: changeInputHandler
                        })
                    ]
                })
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default())["multi-select-dropdown"]} ltrStyle  ${(styles_module_default()).checkbox}`,
                children: renderOptions()?.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "flex justify-center items-center p-4",
                    children: "No Matches Found"
                }) : renderOptions()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "pt-2 block",
                children: [
                    errorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(styles_module_default())["error-message"]}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: errorText
                        })
                    }),
                    noteText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(styles_module_default())["field-note"]}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: noteText
                        })
                    })
                ]
            })
        ]
    });
}
const X = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-x",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "9",
                y1: "3",
                x2: "3",
                y2: "9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "3",
                y1: "3",
                x2: "9",
                y2: "9"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/lib/capitalizeFirstLetter.ts
var capitalizeFirstLetter = __webpack_require__(8712);
;// CONCATENATED MODULE: ./src/components/shared/contactUs/contactUsForm.tsx
/* eslint-disable react/display-name */ 










function ContactUsForm(props) {
    const { domain , domainNameTranslation  } = (0,useDomainContext/* useDomainContext */.w)();
    const translatedContactUsFormTcpa = domain?.translations?.[`${domainNameTranslation}_contactUsFormTcpa`];
    const { severalBrandsRecaptcha  } = props;
    const getTranslationKey = (field, filedName)=>{
        const capitalizeFiledName = filedName?.charAt(0)?.toUpperCase() + filedName?.slice(1);
        return `${domainNameTranslation}_contactUsForm${capitalizeFiledName}${field}`;
    };
    const getFallBackFields = ()=>{
        let fallBackFields = null;
        if (severalBrandsRecaptcha) {
            fallBackFields = Object.keys(contactUsForm/* mainContactUsForm */.A)?.filter((el)=>el !== "recaptcha");
        } else {
            fallBackFields = Object.keys(contactUsForm/* mainContactUsForm */.A);
        }
        return fallBackFields?.map((itemKey)=>{
            return {
                ...contactUsForm/* mainContactUsForm */.A[itemKey],
                label: domain?.translations?.[getTranslationKey("Label", itemKey)] ?? contactUsForm/* mainContactUsForm */.A[itemKey]?.label,
                placeholder: domain?.translations?.[getTranslationKey("Placeholder", itemKey)] ?? contactUsForm/* mainContactUsForm */.A[itemKey]?.placeholder
            };
        });
    };
    const { primaryColor , secondaryColor , fields =getFallBackFields() , classes , domainInfo , submitButtonTitle =domain?.translations?.[`${domainNameTranslation}_contactUsMainSubmitButton`] ?? "send" , setSubmittedForm , doNotSellForm , colors , type , category , isConnectPageForm ,  } = props;
    const { handleFieldBlur , handleSubmit , handleFieldChange , submitted , loadingForm , formError , fieldsState ,  } = (0,useContactUsForm/* useContactUsForm */.X)(fields, severalBrandsRecaptcha, setSubmittedForm, doNotSellForm, type, category, isConnectPageForm);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex items-center h-full relative ${(styles_module_default())["contact-us-form-wrapper"]} `,
        children: [
            !submitted && fieldsState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                style: {
                    color: secondaryColor ?? "black",
                    "--primary-color": primaryColor ?? ""
                },
                className: `${(styles_module_default()).form} ${classes?.formClassName ?? ""}`,
                children: [
                    fields.map((field)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
                            field: field,
                            fieldState: fieldsState[field.name],
                            onChange: handleFieldChange,
                            onBlur: handleFieldBlur,
                            classes: classes,
                            domainInfo: domainInfo,
                            doNotSellForm: doNotSellForm,
                            fields: fields
                        }, field.name)),
                    formError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            color: " #f75959"
                        },
                        className: "form-error text-sm font-light mb-3",
                        children: formError
                    }),
                    props.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes?.messageClassName,
                        children: props.message
                    }),
                    translatedContactUsFormTcpa ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            fontSize: "12px",
                            color: "#888"
                        },
                        dangerouslySetInnerHTML: {
                            __html: translatedContactUsFormTcpa?.replace(/\$\{submitButtonTitle\}/gi, submitButtonTitle)
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            fontSize: "12px",
                            color: "#888"
                        },
                        children: [
                            'By clicking on the "',
                            submitButtonTitle,
                            '" button below, you expressly consent to receive marketing communications from us, and our affiliates and partners regarding our services, by email, text message or phone (including via automatic telephone dialing system or pre-recorded voice messages) to the landline or mobile number provided, even if that telephone number is on a corporate, state, or national Do Not Call Registry. For more information see our ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/privacy-policy",
                                children: "Privacy Policy"
                            }),
                            " ",
                            "and",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/terms-and-conditions",
                                children: "Terms and Conditions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col xl:flex-row items-center justify-between mt-4 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            style: {
                                backgroundColor: primaryColor ?? "black",
                                color: "white"
                            },
                            className: `rounded-md relative font-bold flex items-center justify-center px-5 py-3 mt-8 xl:mt-0 w-full lg:w-40 ${classes?.submitButtonClassName ?? ""}`,
                            type: "submit",
                            loading: loadingForm,
                            children: submitButtonTitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${classes?.thankYouStepClassName ?? ""} success flex w-full h-full z-10  flex-col justify-center left-0 top-0 items-center pointer-events-none select-none transition-opacity ${submitted ? "opacity-100 visible" : "opacity-0 invisible absolute"}`,
                children: [
                    submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationCheck, {
                        color: colors?.thankYouColorIcon ?? primaryColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-col justify-center items-center text-center flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                style: {
                                    color: colors?.thankYouColorText ?? primaryColor ?? "black"
                                },
                                className: "text-3xl font-bold",
                                children: domain?.translations?.[`${domainNameTranslation}_contactUsFormThankYou`] ?? "Thank You"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-semibold mt-4",
                                style: {
                                    color: colors?.thankYouColorText ?? primaryColor ?? "black"
                                },
                                children: doNotSellForm ? domain?.translations?.[`${domainNameTranslation}_contactUsFormSorryToSeeYouGo`] ?? "Sorry to see you go!" : domain?.translations?.[`${domainNameTranslation}_contactUsFormYourMessageHasBeenSent`] ?? "Your Message has been sent."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm mt-1",
                                style: {
                                    color: colors?.thankYouColorText ?? primaryColor ?? "black"
                                },
                                children: doNotSellForm ? domain?.translations?.[`${domainNameTranslation}_contactUsFormYouHaveNowBeenRemovedFromOurList`] ?? "You have now been removed from our list." : domain?.translations?.[`${domainNameTranslation}_contactUsFormOurSupportStaffWillGetBackToYouWithin24Hours`] ?? "Our support staff will get back to you within 24 hours"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const Field = ({ field , fieldState , onChange , onBlur , classes , domainInfo , doNotSellForm , fields  })=>{
    const { domain , doNotSellFormStates  } = (0,useDomainContext/* useDomainContext */.w)();
    const streetAddressRef = (0,react.useRef)(null);
    let autoComplete;
    const formattedGoogleAddress = (addressObject)=>{
        const newAddressObject = {};
        addressObject.forEach((addressComponent)=>{
            const keyName = addressComponent.types[0];
            newAddressObject[keyName === "postal_code" ? "zipCode" : keyName] = addressComponent;
        });
        return newAddressObject;
    };
    const handlePlaceSelect = ()=>{
        const placeSelectResults = autoComplete.getPlace();
        if (!placeSelectResults?.address_components) {
            // setError("Invalid Street Address");
            // onChange(getZipCodeField(fields), "");
            return;
        }
        const address = formattedGoogleAddress(placeSelectResults.address_components);
        const streetNumber = address?.street_number?.short_name ?? "";
        const route = address.route?.long_name ?? "";
        const zipCode = address?.zipCode?.short_name ?? "";
        const state = address?.administrative_area_level_1?.long_name ?? "";
        if (zipCode) {
            const zipCodeField = fields.find((i)=>i.name === "zipCode");
            if (zipCodeField) onChange(zipCodeField, zipCode);
        }
        if (state) {
            const stateField = fields.find((i)=>i.name === "state");
            if (stateField) onChange(stateField, `crmCompanyStates_${state}`);
        }
        const val = `${streetNumber} ${route}`.trim();
        onChange(field, val);
    };
    const handleGooglePlacesScriptLoaded = ()=>{
        if (streetAddressRef.current !== null) {
            autoComplete = new window.google.maps.places.Autocomplete(streetAddressRef.current, {
                types: [
                    "address"
                ],
                componentRestrictions: {
                    country: "us"
                },
                fields: [
                    "address_component",
                    "adr_address",
                    "alt_id",
                    "formatted_address",
                    "geometry",
                    "name", 
                ]
            });
            autoComplete.addListener("place_changed", ()=>{
                handlePlaceSelect();
            });
        }
    };
    const loadGooglePlacesScript = (callback)=>{
        if (document.getElementById("googleStreetAddress")) {
            callback();
            return;
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "googleStreetAddress";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${"AIzaSyAMvrXPGjHZcAH-ro9eCRFpOOm_taXvBGQ"}&libraries=places,geometry&callback=handleGooglePlacesScriptLoaded`;
        document.getElementsByTagName("head")[0].appendChild(script);
    };
    (0,react.useEffect)(()=>{
        if (field.inputType === "streetAddress") {
            loadGooglePlacesScript(handleGooglePlacesScriptLoaded);
            // @ts-ignore
            window["handleGooglePlacesScriptLoaded"] = handleGooglePlacesScriptLoaded;
        }
    }, []);
    const gettingField = (type)=>{
        switch(type){
            case "text":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    value: fieldState.value,
                    onChange: (e)=>onChange(field, e.target.value),
                    placeholder: field.placeholder,
                    autoComplete: field.autocomplete,
                    onBlur: (e)=>onBlur(field, e.target.value),
                    name: field.name,
                    id: field.name,
                    className: `${classes?.fieldClassName ?? ""} ${(styles_module_default()).field}`
                });
            case "hidden":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    value: fieldState.value,
                    onChange: (e)=>onChange(field, e.target.value),
                    name: field.name,
                    id: field.name,
                    hidden: true
                });
            case "textarea":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    onChange: (e)=>onChange(field, e.target.value),
                    value: fieldState.value,
                    placeholder: field.placeholder,
                    autoComplete: field.autocomplete,
                    onBlur: (e)=>onBlur(field, e.target.value),
                    name: field.name,
                    id: field.name,
                    className: `${classes?.fieldClassName ?? ""} ${(styles_module_default()).textarea} ${(styles_module_default()).field}`,
                    rows: field.rows
                });
            case "checkbox":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    onChange: (e)=>{
                        onChange(field, String(e.target.checked));
                    },
                    checked: fieldState.value === "true",
                    type: "checkbox",
                    name: field.name,
                    id: field.name,
                    className: `${(styles_module_default())["custom-checkbox"]} ${classes?.checkBoxClassName ?? ""}`
                });
            case "checkbox-group":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `${(styles_module_default()).checkboxGroup} ${classes?.checkboxGroupClassName ?? ""}`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "mr-3 lg:mr-10 text-sm sm:text-base",
                            children: field.label
                        }),
                        field?.options?.map((option, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).option,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        id: `${field.name}-${option.value}`,
                                        name: field.name,
                                        value: option.value,
                                        className: "mx-3",
                                        checked: fieldState.value.includes(option.value),
                                        onChange: (e)=>{
                                            const value = e.target.value;
                                            const checked = e.target.checked;
                                            if (checked) {
                                                onChange(field, fieldState.value ? `${fieldState.value},${value}` : value);
                                            } else {
                                                onChange(field, fieldState.value?.split(",").filter((item)=>item !== value).join(","));
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        htmlFor: `${field.name}-${option.value}`,
                                        className: "flex items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (styles_module_default()).box,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    viewBox: "0,0,50,50",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M5 30 L 20 45 L 45 5"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm",
                                                children: option.label
                                            })
                                        ]
                                    }, index)
                                ]
                            }, option.value))
                    ]
                });
            case "select":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                    className: `${(styles_module_default()).field} ${(styles_module_default()).select} ${!fieldState.value ? (styles_module_default()).empty : ""} ${classes?.selectFieldClassName ?? ""}`,
                    onChange: (e)=>onChange(field, e.target.value),
                    name: field.name,
                    value: fieldState.value,
                    id: field.name,
                    children: [
                        field.placeholder && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: field.placeholder
                        }),
                        doNotSellForm ? doNotSellFormStates?.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.id)) : field.options?.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.id))
                    ]
                });
            case "streetAddress":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    value: fieldState.value,
                    ref: streetAddressRef,
                    onChange: (e)=>onChange(field, e.target.value),
                    className: `${(styles_module_default()).field} ${(styles_module_default()).streetAddress} ${classes?.fieldClassName ?? ""}`,
                    placeholder: field.placeholder ?? undefined,
                    autoComplete: "off",
                    type: type,
                    name: field.name ?? undefined,
                    onBlur: (e)=>onBlur(field, e.target.value),
                    id: field.name
                });
            case "multiSelect":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect, {
                    onChange: (val)=>onChange(field, val),
                    value: fieldState?.value,
                    // className={`${} ${
                    //     styles["multiSelect"]
                    // } ${classes?.fieldClassName ?? ""}`}
                    fieldClassName: `${(styles_module_default()).field} ${classes?.fieldClassName ?? ""}`,
                    containerClassName: classes?.multiSelectFieldClassName,
                    field: field
                });
            case "recaptcha":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: domain?.recaptchaConfig?.key ?? domainInfo?.recaptchaConfig?.key ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                        sitekey: domain?.recaptchaConfig?.key ?? domainInfo?.recaptchaConfig?.key ?? "",
                        onChange: (value)=>{
                            onChange(field, value ?? "");
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: `${field.name}-field`,
        className: `${(styles_module_default())["field-wrapper"]} ${!fieldState.valid ? (styles_module_default())["has-error"] : ""} ${classes?.fieldWrapperClassName ?? ""}`,
        style: {
            ...field.inputType === "hidden" ? {
                display: "none"
            } : {},
            ...field.name === "subject" || field.name === "body" ? {
                width: "100%"
            } : {}
        },
        children: [
            field.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: field.name,
                className: field.inputType === "checkbox" ? fieldState.value === "true" ? `${(styles_module_default()).checkboxLabel} ${(styles_module_default()).checkboxLabelChecked}` : (styles_module_default()).checkboxLabel : "",
                children: field.label
            }),
            gettingField(field.inputType),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default())["field-error"]} ${classes?.fieldErrorClassName ?? ""}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,capitalizeFirstLetter/* capitalizeFirstLetter */.f)(fieldState?.errorMessage)
                })
            })
        ]
    });
};


/***/ }),

/***/ 95301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Loader({ size , className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `flex items-center ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "animate-loader-spin",
            style: {
                width: `${size}px`,
                height: `${size}px`
            },
            role: "progressbar",
            color: "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: "block",
                viewBox: "22 22 44 44",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    style: {
                        stroke: "currentcolor",
                        strokeDasharray: "80px,200px",
                        strokeDashoffset: 0
                    },
                    cx: "44",
                    cy: "44",
                    r: "20.2",
                    fill: "none",
                    strokeWidth: "3.6"
                })
            })
        })
    });
}


/***/ }),

/***/ 77720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ useContactUsForm; }
});

// UNUSED EXPORTS: formReducer

// EXTERNAL MODULE: ./src/lib/shared/contactUsForm.ts
var contactUsForm = __webpack_require__(37695);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
;// CONCATENATED MODULE: ./src/lib/contactUsUtils.ts
const getFinalContactUsFields = ({ severalBrandsRecaptcha , defaultFormFields , extraFields , token , doNotSellForm , visitId , domainId  })=>{
    if (doNotSellForm) {
        return {
            ...defaultFormFields,
            name: undefined,
            domainId,
            visitId,
            deleteMyInfo: !!defaultFormFields.deleteMyInfo,
            doNotSell: !!defaultFormFields.doNotSell
        };
    }
    return severalBrandsRecaptcha ? {
        ...defaultFormFields,
        name: undefined,
        customFields: extraFields,
        googleReCaptcha: token
    } : {
        ...defaultFormFields,
        customFields: extraFields
    };
};

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/hooks/useContactUsForm.tsx







var ActionTypes;
(function(ActionTypes) {
    ActionTypes["SET_FIELDS_STATE"] = "SET_FIELDS_STATE";
    ActionTypes["SET_LOADING_FORM"] = "SET_LOADING_FORM";
    ActionTypes["SET_FORM_SUBMITTED"] = "SET_FORM_SUBMITTED";
    ActionTypes["SET_FORM_ERROR"] = "SET_FORM_ERROR";
})(ActionTypes || (ActionTypes = {}));
const initState = {
    submitted: false,
    loadingForm: false,
    fieldsState: null,
    formError: null
};
const formReducer = (state, action)=>{
    switch(action.type){
        case ActionTypes.SET_FIELDS_STATE:
            return {
                ...state,
                fieldsState: {
                    ...state.fieldsState,
                    ...action.payload
                }
            };
        case ActionTypes.SET_LOADING_FORM:
            return {
                ...state,
                loadingForm: action.payload
            };
        case ActionTypes.SET_FORM_SUBMITTED:
            return {
                ...state,
                submitted: true
            };
        case ActionTypes.SET_FORM_ERROR:
            return {
                ...state,
                formError: action.payload
            };
        default:
            return state;
    }
};
const useContactUsForm = (formFields, severalBrandsRecaptcha, setSubmittedForm, doNotSellForm, type, category, isConnectPageForm)=>{
    const { executeRecaptcha  } = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)();
    const { visitDetails , domain , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const { fields  } = useFields(formFields);
    const { 0: state , 1: dispatch  } = (0,react.useReducer)(formReducer, {
        ...initState,
        fieldsState: fields
    });
    const { submitted , loadingForm , fieldsState , formError  } = state;
    const handleFieldValidation = async (field, dispatchState)=>{
        const { valid , message  } = await (0,contactUsForm/* fieldValidation */.w)(field, fieldsState[field.name].value, domain, locale);
        const newObj = {};
        newObj[field.name] = {
            ...fieldsState[field.name],
            valid,
            errorMessage: message
        };
        if (dispatchState) {
            dispatch({
                type: ActionTypes.SET_FIELDS_STATE,
                payload: {
                    ...newObj
                }
            });
        }
        return {
            name: field.name,
            valid: valid,
            errorMessage: message,
            value: fieldsState[field.name].value
        };
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (loadingForm || submitted) return;
        dispatch({
            type: ActionTypes.SET_LOADING_FORM,
            payload: true
        });
        const formFieldValidation = [];
        for (const promise of formFields){
            const result = await handleFieldValidation(promise, false);
            formFieldValidation.push(result);
        }
        const finalObj = formFieldValidation.reduce((obj, currentValue)=>{
            obj[currentValue.name] = {
                valid: currentValue.valid,
                errorMessage: currentValue.errorMessage,
                value: currentValue.value
            };
            return obj;
        }, {});
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...finalObj
            }
        });
        const formValid = !formFieldValidation.map((filed)=>filed.valid).includes(false);
        if (formValid) {
            const defaultFormFields = {};
            const extraFields = [];
            if (category) {
                extraFields.push({
                    key: "category",
                    value: category
                });
            }
            if (isConnectPageForm) {
                extraFields.push({
                    key: "source",
                    value: "connect"
                });
            }
            const trustedFormCertificateUrl = document.getElementById("TrustedFormCertUrl_0")?.value || "";
            if (trustedFormCertificateUrl) {
                extraFields.push({
                    key: "trustedFormCertificateUrl",
                    value: trustedFormCertificateUrl
                });
            }
            formFields.forEach((field)=>{
                if (field.isExtraField) {
                    extraFields.push({
                        key: field.name,
                        value: fieldsState[field.name].value
                    });
                } else {
                    if (field.name === "name") {
                        const name = fieldsState[field.name].value.split(" ");
                        defaultFormFields["firstName"] = name[0];
                        defaultFormFields["lastName"] = name[1] ?? "---";
                    }
                    defaultFormFields[field.name] = fieldsState[field.name].value;
                }
            });
            dispatch({
                type: ActionTypes.SET_FORM_ERROR,
                payload: null
            });
            const token = executeRecaptcha && severalBrandsRecaptcha ? await executeRecaptcha("contact_us_form") : null;
            const finalData = getFinalContactUsFields({
                severalBrandsRecaptcha,
                defaultFormFields,
                extraFields,
                token,
                doNotSellForm,
                visitId: visitDetails?.visitId,
                domainId: domain?.id
            });
            let resData = null;
            let resError = null;
            if (doNotSellForm) {
                const { data , error  } = await (0,api/* submitDoNotSellForm */.TF)({
                    //@ts-ignore
                    fields: {
                        ...finalData
                    }
                });
                resData = data;
                resError = error;
            } else {
                const { data: data1 , error: error1  } = await (0,api/* submitContactUsForm */.F2)({
                    //@ts-ignore
                    fields: {
                        ...finalData
                    },
                    type
                });
                resData = data1;
                resError = error1;
            }
            dispatch({
                type: ActionTypes.SET_LOADING_FORM,
                payload: false
            });
            if (resError) {
                if (resData && resData?.code === "INVALID_PHONE_NUMBER_FORMAT") {
                    dispatch({
                        type: ActionTypes.SET_FORM_ERROR,
                        payload: "Invalid phone number"
                    });
                } else {
                    dispatch({
                        type: ActionTypes.SET_FORM_ERROR,
                        payload: "An error has occurred, please try again later"
                    });
                }
            } else {
                if (setSubmittedForm) {
                    setSubmittedForm(true);
                }
                dispatch({
                    type: ActionTypes.SET_FORM_SUBMITTED,
                    payload: undefined
                });
            }
        } else {
            dispatch({
                type: ActionTypes.SET_LOADING_FORM,
                payload: false
            });
        }
    };
    const handleFieldBlur = async (field)=>{
        await handleFieldValidation(field, true);
    };
    const handleFieldChange = (field, val)=>{
        const newVal = field.validation.rules?.type === "isPhone" && val ? (0,shared_form/* handleFieldMasking */.yr)("us-phone", val) : val;
        const newObj = {};
        newObj[field.name] = {
            valid: true,
            errorMessage: "",
            value: newVal
        };
        dispatch({
            type: ActionTypes.SET_FIELDS_STATE,
            payload: {
                ...newObj
            }
        });
    };
    return {
        handleSubmit,
        handleFieldBlur,
        handleFieldChange,
        submitted,
        loadingForm,
        formError,
        fieldsState
    };
};
const useFields = (fields)=>{
    const temp = {};
    fields.forEach((field)=>{
        temp[field.name] = {
            value: field.defaultValue ?? "",
            valid: true,
            errorMessage: ""
        };
    });
    return {
        fields: temp
    };
};


/***/ }),

/***/ 37695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ mainContactUsForm; },
/* harmony export */   "w": function() { return /* binding */ fieldValidation; }
/* harmony export */ });
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21513);
/* harmony import */ var _lib_shared_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(198);
/* harmony import */ var _lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8712);



const mainContactUsForm = {
    firstName: {
        name: "firstName",
        label: "First Name",
        placeholder: "First Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "given-name",
        serverSideValidation: true
    },
    lastName: {
        name: "lastName",
        label: "Last Name",
        placeholder: "Last Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty"
            }
        },
        autocomplete: "family-name",
        serverSideValidation: true
    },
    email: {
        name: "email",
        label: "Email",
        placeholder: "Email",
        inputType: "text",
        type: "email",
        validation: {
            required: true,
            rules: {
                type: "isEmail"
            }
        },
        autocomplete: "email",
        serverSideValidation: true
    },
    phoneNumber: {
        name: "phone",
        label: "Phone Number",
        placeholder: "Phone Number",
        inputType: "text",
        type: "tel",
        validation: {
            required: true,
            rules: {
                type: "isPhone"
            }
        },
        autocomplete: "tel"
    },
    subject: {
        name: "subject",
        label: "Subject",
        placeholder: "Subject",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 3,
                    max: 255
                }
            }
        }
    },
    description: {
        name: "body",
        label: "Description",
        placeholder: "Please enter the details of your request. A member of our support staff will get back to you within 24 hours",
        inputType: "textarea",
        type: null,
        rows: 5,
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 5,
                    max: 255
                }
            }
        }
    },
    recaptcha: {
        name: "googleReCaptcha",
        label: "",
        placeholder: "",
        inputType: "recaptcha",
        type: null,
        validation: {
            required: true
        }
    }
};
const getErrorMessage = (fieldName, errorCode, locale, options = {})=>{
    switch(errorCode){
        case "REQUIRED":
            switch(locale){
                case "ar":
                    return `${fieldName} مطلوب`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} es requerido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} is required`);
            }
        case "INVALID_EMAIL":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "INVALID_PHONE":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "INVALID_STREET_ADDRESS":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ${fieldName} صالح`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca un ${fieldName} válido`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter a valid ${fieldName}`);
            }
        case "MAX_LENGTH_EXCEEDED":
            switch(locale){
                case "ar":
                    return `${fieldName} لا يمكن أن يكون أكثر من ${options?.maxCount?.toString()} أحرف`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} no puede tener más de ${options?.maxCount?.toString()} caracteres`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`${fieldName} cannot be more than ${options?.maxCount?.toString()} characters`);
            }
        case "MIN_LENGTH_NOT_MET":
            switch(locale){
                case "ar":
                    return `يرجى إدخال ما لا يقل عن ${options?.minCount?.toString()} أحرف`;
                case "es":
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Por favor, introduzca por lo menos ${options?.minCount?.toString()} caracteres`);
                case "en":
                default:
                    return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Please enter at least ${options?.minCount?.toString()} characters`);
            }
        default:
            return (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)(`Invalid ${fieldName}`);
    }
};
const fieldValidation = async (field, value, domain, locale)=>{
    const conditions = [];
    const fieldName = field.errorMessageLabel || field.label || field.name;
    if (!value) {
        if (field.validation.required) {
            const fieldLabel = {
                en: "This field",
                es: "Este campo",
                // cspell:disable-next-line
                ar: "هذا الحقل"
            };
            conditions.push({
                valid: false,
                message: getErrorMessage(fieldLabel[locale] || fieldLabel["en"], "REQUIRED", locale)
            });
        }
    } else {
        if (field.validation.rules?.type === "isEmail") {
            const reg = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            const isValid = reg.test(String(value).toLowerCase());
            !isValid && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_EMAIL", locale)
            });
        }
        if (field.validation.rules?.type === "isPhone") {
            const reg1 = new RegExp(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/);
            const isValid1 = reg1.test(String(value).toLowerCase());
            !isValid1 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_PHONE", locale)
            });
        }
        if (field.validation.rules?.type === "isStreetAddress") {
            // must start with a number and contain at least one letter
            const reg2 = new RegExp(/^\s*\d+\s+([a-zA-Z0-9\s\.,#\-]+)\s*$/);
            const isValid2 = reg2.test(String(value).toLowerCase());
            !isValid2 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "INVALID_STREET_ADDRESS", locale)
            });
        }
        if (field.validation.rules?.characterCount?.max) {
            const isValid3 = value.trim().length <= field.validation.rules?.characterCount?.max;
            !isValid3 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "MAX_LENGTH_EXCEEDED", locale, {
                    maxCount: field.validation.rules?.characterCount?.max
                })
            });
        }
        if (field.validation.rules?.characterCount?.min) {
            const isValid4 = value.trim().length >= field.validation.rules?.characterCount?.min;
            !isValid4 && conditions.push({
                valid: false,
                message: getErrorMessage(fieldName, "MIN_LENGTH_NOT_MET", locale, {
                    minCount: field.validation.rules?.characterCount?.min
                })
            });
        }
    }
    if (conditions.length >= 1) {
        return {
            valid: false,
            message: conditions[0].message
        };
    }
    if (field.serverSideValidation) {
        const { error  } = await (0,src_api__WEBPACK_IMPORTED_MODULE_0__/* .validateField */ .OP)({
            ruleName: field.name,
            value
        });
        if (error) {
            return {
                valid: false,
                message: (0,_lib_capitalizeFirstLetter__WEBPACK_IMPORTED_MODULE_2__/* .capitalizeFirstLetter */ .f)((0,_lib_shared_form__WEBPACK_IMPORTED_MODULE_1__/* .getServerSideValidationErrorMessage */ .V2)(error, fieldName, domain, locale))
            };
        }
    }
    const valid = true;
    const message = "";
    return {
        valid,
        message
    };
};


/***/ }),

/***/ 64655:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__9Mm1_","inner":"button_inner__QZMhk","label":"button_label__3gHtT","icon":"button_icon__LcCwy"};

/***/ }),

/***/ 58509:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"success-checkmark":"confirmationCheck_success-checkmark___gIP4","check-icon":"confirmationCheck_check-icon__J_4Tq","rotate-circle":"confirmationCheck_rotate-circle__YTnZs","icon-line":"confirmationCheck_icon-line__3JNCd","line-tip":"confirmationCheck_line-tip__ojqhj","icon-line-tip":"confirmationCheck_icon-line-tip__kIABl","line-long":"confirmationCheck_line-long__zzBOS","icon-line-long":"confirmationCheck_icon-line-long__cMRSJ","icon-circle":"confirmationCheck_icon-circle__wsrf_","icon-fix":"confirmationCheck_icon-fix__FEZIM"};

/***/ }),

/***/ 9800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact-us-form-wrapper":"styles_contact-us-form-wrapper__PeORF","form":"styles_form__t_wUU","field-wrapper":"styles_field-wrapper__ZbMWo","field-error":"styles_field-error__IJe9d","field":"styles_field__ySbgy","custom-checkbox":"styles_custom-checkbox__O1ghB","checkboxLabel":"styles_checkboxLabel__O1LtU","checkboxLabelChecked":"styles_checkboxLabelChecked__vgAYf","select":"styles_select__RzhZ5","empty":"styles_empty__AjYcs","checkboxGroup":"styles_checkboxGroup__Bw2KN","option":"styles_option__b79Tc","box":"styles_box__aBlgv","selectFieldTitle":"styles_selectFieldTitle__cWgpx","multi-select":"styles_multi-select__fXpQO","multi-select-input-container":"styles_multi-select-input-container__o49EQ","active":"styles_active__yYA_n","multi-select-tags":"styles_multi-select-tags__OhqGU","tag":"styles_tag___p7pg","multi-select-input":"styles_multi-select-input__U3QNI","multi-select-dropdown":"styles_multi-select-dropdown__N1KXZ","with-tooltip":"styles_with-tooltip__Xq9Px"};

/***/ })

}]);